import { defineMessages } from 'react-intl';

export const messages: {
	invalidUrl: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	invalidUrl: {
		id: 'proforma-form-renderer.common.utils.validators.url.invalid-url',
		defaultMessage: 'Must be a valid URL e.g. https://www.google.com/images',
		description: 'Validation message for field with invalid URL.',
	},
});
